import { DomainList } from "@/components/domain";
import { useGetAllReservationServicesWithfulfillments } from "@/hooks/reservation-services";
import { ServiceFulfillment } from "@/models";
import { useMemo } from "react";
import { ServiceFulfillmentView } from "./view-item";

export function ViewServices({ id }: { id: string }) {
  const query = useGetAllReservationServicesWithfulfillments(id);
  const data = useMemo(() => {
    return query.data
      ?.map(
        (d) =>
          d.fulfillments?.map<ServiceFulfillment>((f) => ({
            ...f,
            serviceId: d.serviceId,
          })) ?? [],
      )
      .flat();
  }, [query.data]);
  return (
    <DomainList
      domain="reservations.fulfillments.service"
      hidePageHeader
      noOutlet
      tableOptions={{
        hasActions: true,
        columns: [
          {
            header: "reservations.fulfillments.table.service",
          },
          {
            header: "reservations.fulfillments.table.serviceProviderId",
          },
          {
            header: "reservations.fulfillments.table.value",
          },
          {
            header: "reservations.fulfillments.table.dueDate",
          },
          {
            header: "reservations.fulfillments.table.state",
          },
          {
            header: "reservations.fulfillments.table.agencyCharge",
          },
          {
            header: "reservations.fulfillments.table.expenses",
          },
          {
            header: "reservations.fulfillments.table.invoiceNumber",
          },
        ],
      }}
      type="table"
      data={data}
      isLoading={query.isLoading}
      newLink="/reservations/$id/fulfillments/new/service"
      newLinkParams={{ id }}
      renderItem={(fulfillment, _, isTable) => (
        <ServiceFulfillmentView
          fulfillment={fulfillment}
          key={fulfillment.id}
          reservationId={id}
          isTable={isTable}
        />
      )}
    />
  );
}
